<div class="row mb-5 doc-vente-devis-form" style="margin-top:2%">
    <div class="col-12">
        <div class="row mb-2 align-items-end">
            <div class="col-lg-4 col-md-6 mb-3 mb-md-0">
                <label class="d-block mb-1" for="labelDevis">Label</label>
                <input
                    id="labelDevis"
                    type="text"
                    class="form-control"
                    name="labelDevis"
                    [(ngModel)]="labelText"
                    [placeholder]="documentTypeLabel"
                />
            </div>
            <div class="col-lg-4 col-md-6">
                <label class="d-block mb-1" for="couleurDevis">Couleur du document</label>
                <div class="doc-vente-color-wrap">
                    <span class="doc-vente-color-value">{{ couleurText }}</span>
                    <input
                        id="couleurDevis"
                        type="color"
                        class="doc-vente-color-input"
                        name="couleurDevis"
                        [(ngModel)]="couleurText"
                        title="Choisir une couleur"
                    />
                </div>
            </div>
        </div>

        <div class="mb-3">
            <label class="form-label text-muted size15 d-block mb-2">Date limite de paiement</label>
            <div class="doc-vente-devis-date-row">
                <div class="doc-vente-devis-radio-inline">
                    <div class="org-radio-wrapper doc-vente-devis-org-radio">
                        <input type="radio" name="dateLimiteDevis" id="dlJours" class="org-radio-input" [value]="'jours'" [(ngModel)]="datePaiement">
                        <label class="org-radio-label" for="dlJours"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 doc-vente-devis-radio-caption mb-0" for="dlJours">Jours</label>
                </div>
                <div class="doc-vente-devis-radio-inline">
                    <div class="org-radio-wrapper doc-vente-devis-org-radio">
                        <input type="radio" name="dateLimiteDevis" id="dlMois" class="org-radio-input" [value]="'mois'" [(ngModel)]="datePaiement">
                        <label class="org-radio-label" for="dlMois"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 doc-vente-devis-radio-caption mb-0" for="dlMois">Mois</label>
                </div>
                <div class="doc-vente-devis-radio-inline">
                    <div class="org-radio-wrapper doc-vente-devis-org-radio">
                        <input type="radio" name="dateLimiteDevis" id="dlAnnee" class="org-radio-input" [value]="'annee'" [(ngModel)]="datePaiement">
                        <label class="org-radio-label" for="dlAnnee"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 doc-vente-devis-radio-caption mb-0" for="dlAnnee">Année</label>
                </div>
                <div class="doc-vente-devis-stepper d-flex align-items-stretch flex-shrink-0">
                    <button type="button" class="minus-button-left"
                            (click)="decrement()"
                            [disabled]="disabledValueDecrement">-</button>
                    <input style="width: 90px; border-radius: 0"
                           type="number"
                           class="form-control text-center align-self-stretch"
                           name="minStock"
                           [(ngModel)]="numberValue"
                           (ngModelChange)="emitChange(numberValue)"/>
                    <button type="button" class="minus-button-right"
                            (click)="increment()"
                            [disabled]="disabledValueIncrement">+</button>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="totalCheckbox" name="insrOrig" [(ngModel)]="insrOrigArtcl">
                <label class="custom-control-label" for="totalCheckbox">
                    Insérer l'origine des articles
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="contactCheckbox" name="affMt" [(ngModel)]="affMontantTotaux">
                <label class="custom-control-label" for="contactCheckbox">
                    Afficher les montants totaux
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="contact" name="affContact" [(ngModel)]="affInfContact">
                <label class="custom-control-label" for="contact">
                    Afficher les informations de contact
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="desc" name="affDesc" [(ngModel)]="affCourteDesp">
                <label class="custom-control-label" for="desc">
                    Afficher une courte description
                </label>
            </div>
        </div>
        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="info" name="affInfos" [(ngModel)]="affInfos">
                <label class="custom-control-label" for="info">
                    Afficher les informations
                </label>
            </div>
        </div>

        <div class="mb-1"><hr class="m-0 divis"></div>

        <div class="mb-2">
            <label class="form-check-label label-large d-block mb-2" for="noteDevis">
                Note
            </label>
            <textarea id="noteDevis" class="form-control note" name="noteDevis" [(ngModel)]="noteText" placeholder="Saisissez une note" rows="4"></textarea>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end align-items-center flex-wrap w-100 position-fixed-bottom mt-2 mb-2">
    <a class="btn btn-grey waves-effect m-1" routerLink="/main/parametre/document">Annuler</a>
    <button type="button" class="btn btn-green waves-effect m-1" (click)="appercue()">Aperçu de la configuration</button>
    <button type="button" class="btn btn-primary waves-effect m-1" (click)="saveParametreDocument()" [disabled]="saving">{{ saving ? 'Enregistrement…' : 'Enregistrer' }}</button>
</div>







